import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Axios from "axios";
import document from "../document.svg";
import ResponseModal from "./ResponseModal";
import Typography from "@material-ui/core/Typography";
import * as moment from "moment";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import Styles from "../index.module.scss";
import UrlLinks from "../../../UrlLinks";
import DownloadBlue from "../Group 3238.svg";
import DownloadGrey from "../Group 3239.svg";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    borderBottom: "unset",
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#1c4980",
    },
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const {
    openOnboardingModal,
    setOpenOnboardingModal,
    showToast,
    updateMyData,
  } = props;
  const [excel, setExcel] = useState(null);
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [name, setName] = useState("");
  const [excelError, setExcelError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [invalidData, setInvalidData] = useState();
  const [checked, setChecked] = useState(false);
  const [responseData, setResponseData] = useState();
  const [closeFile, setCloseFile] = useState(true);
  const [disableRole, setDisableRole] = useState(true);
  const [isVerifier, setIsVerifier] = useState(null);

  const handleClose = () => {
    setOpenOnboardingModal(false);
  };

  const handleCloseFile = () => {
    setName("");
    setCloseFile(true);
  };

  const handleRoleData = (event) => {
    setDisableRole(false);
    if (event.target.value === "lmd") {
      setIsVerifier(0);
    } else if (event.target.value === "nonLmd") {
      setIsVerifier(1);
    }
  };

  useEffect(() => {
    setName("");
  }, [isVerifier]);

  const handleUpload = (event) => {
    const fileExtension = event.target.files[0].name.split(".").slice(-1)[0];
    const fileName = event.target.files[0].name;

    if (
      fileExtension.toLowerCase() === "xlsx" ||
      fileExtension.toLowerCase() === "xls"
    ) {
      setName(fileName);
      setExcel(event.target.files[0]);
      setExcelError(false);
      setCloseFile(false);
    } else {
      setExcelError(true);
      setExcel(null);
      setName("");
    }
    setResponseData();
    event.target.value = null;
  };

  let newOnboardingExcelLMD = "/lmd_onboarding_template.xlsx";
  let newOnboardingExcelNonLMD = "/non-lmd_onboarding_tempate.xlsx";

  const createInvalidData = (records) => {
    if (records.length > 1) {
      let list = [];
      records.map((record) => {
        if (record.hasOwnProperty("WorkerDetail")) {
          if (record.WorkerDetail.isWorkerCreated === 0) {
            let firstName = "";
            let lastName = "";
            if (record.WorkerDetail.workerName) {
              var i = record.WorkerDetail.workerName.indexOf(" ");
              if (i > 0) {
                firstName = record.WorkerDetail.workerName.slice(0, i).trim();
                lastName = record.WorkerDetail.workerName
                  .slice(i + 1, record.WorkerDetail.workerName.length)
                  .trim();
              } else {
                firstName = record.WorkerDetail.workerName;
              }
            }
            isVerifier === 0
              ? list.push({
                  "First Name": firstName || "",
                  "Last Name": lastName || "",
                  "Mobile No": record.WorkerDetail.mobileNo || "",
                  "Aadhaar No": "" + record.WorkerDetail.adhaarNo || "",
                  "Source by":
                    record.WorkerDetail.sourceBy === "VENDOR"
                      ? "Vendor"
                      : record.WorkerDetail.sourceBy === "TA"
                      ? "HRBP/TA"
                      : record.WorkerDetail.sourceBy === "EREF"
                      ? "Employee reference"
                      : "",
                  "Vendor Name/Emp id/HRBP or TA id ":
                    record.WorkerDetail.sourceByName || "",
                  "Hub Name/Cluster Name/Zone Name":
                    record.WorkerDetail.hubName || "",
                  Designation: record.WorkerDetail.designation || "",
                  "Joining Date": record.WorkerDetail.dateOfJoining
                    ? moment(record.WorkerDetail.dateOfJoining).format(
                        "DD/MM/YYYY"
                      )
                    : "",
                  EDAB:
                    record.WorkerDetail.physicallyDisabled === 1
                      ? "Yes"
                      : record.WorkerDetail.physicallyDisabled === 0
                      ? "No"
                      : "",
                  "Client Name": record.WorkerDetail.partner || "",
                  "Recruiter Phone Number": record.WorkerDetail.recruiter || "",
                  "Reason for failure": record.WorkerDetail.uploadStatus || "",
                })
              : list.push({
                  "First Name": firstName || "",
                  "Last Name": lastName || "",
                  "Mobile No": record.WorkerDetail.mobileNo || "",
                  "Aadhaar No": "" + record.WorkerDetail.adhaarNo || "",
                  City: record.WorkerDetail.city || "",
                  "Project Name": record.WorkerDetail.project_name || "",
                  "Reason for failure": record.WorkerDetail.uploadStatus || "",
                });
          }
        }
        return true;
      });
      return list.length > 0 ? list : null;
    }
  };
  
  const handleExcel = () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("file", excel);

    Axios.post(
      `${UrlLinks.baseUrl}${
        isVerifier === 0
          ? UrlLinks.workerUrls.uploadExcelForLMD
          : UrlLinks.workerUrls.uploadExcelForNonLMD
      }${localStorage.getItem("userID")}${checked ? "&isAj=1" : ""}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        if (response.data) {
          setInvalidData(createInvalidData(response.data));
          const summary = response.data.slice(-1)[0];
          setResponseData(summary);
          updateMyData();
          setIsLoading(false);
        } else {
          setResponseData([]);
        }
      })
      .catch((error) => {
        console.log({ error });
        setIsLoading(false);
        showToast("error", error.message);
      });
  };

  useEffect(() => {
    if (responseData) {
      setOpenResponseModal(true);
    }
  }, [responseData]);

  let dialogData = (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={openOnboardingModal}
      classes={{ paper: Styles.paper }}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <span>Upload Worker Data</span>
      </DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          row
          aria-label="position"
          name="position"
          defaultValue="top"
        >
          <FormControlLabel
            label="LMD"
            control={<Radio />}
            value="lmd"
            onClick={handleRoleData}
          />
          <FormControlLabel
            label="Non-LMD"
            control={<Radio />}
            value="nonLmd"
            onClick={handleRoleData}
          />
        </RadioGroup>
        <a
          href={
            isVerifier === 0 ? newOnboardingExcelLMD : newOnboardingExcelNonLMD
          }
          download
          target="_blank"
          className={Styles.downloadTemplate}
          style={{ pointerEvents: disableRole ? "none" : "auto" }}
        >
          <span
            style={{ color: disableRole ? "rgba(0, 0, 0, 0.26)" : "#1c4980" }}
          >
            Download File Template
          </span>
          <img
            src={disableRole ? DownloadGrey : DownloadBlue}
            alt="download"
            style={{ color: disableRole ? "rgba(0, 0, 0, 0.26)" : "#1c4980" }}
          />
        </a>

        <Grid item xs={12} className="padding0" style={{ marginTop: "8%" }}>
          <input
            style={{ display: "none" }}
            id="contained-button-file"
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleUpload}
            disabled={disableRole}
          />
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              className={Styles.uploadButton}
              component="span"
              startIcon={
                <img src={document} alt={"upload"} style={{ color: "white" }} />
              }
              disabled={disableRole}
            >
              Browse File
            </Button>
          </label>
        </Grid>
        <Grid item xs={12} className="padding0">
          <span className={`fontSize13 ${excelError ? "redColor" : ""}`}>
            only .xls and .xlsx are allowed
          </span>
        </Grid>
        <Grid item xs={12} className="padding0" style={{ marginTop: "10px" }}>
          {name && (
            <span className={Styles.fileName}>
              {name.length > 70 ? `${name.substring(0, 69)}...` : `${name}`}
              <span>
                <IconButton
                  aria-label="close"
                  style={{ color: "white", paddingRight: "0" }}
                  onClick={handleCloseFile}
                >
                  <CloseIcon />
                </IconButton>
              </span>
            </span>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        {isLoading ? (
          <span>Please wait... it may take few minutes</span>
        ) : (
          <Button
            variant="contained"
            onClick={handleExcel}
            className={`${!excel ? "disabledButton" : "blueButtonContained"}`}
            disabled={!excel}
          >
            Upload
          </Button>
        )}
      </DialogActions>
      {openResponseModal && (
        <ResponseModal
          openResponseModal={openResponseModal}
          setOpenResponseModal={setOpenResponseModal}
          responseData={responseData}
          setOpenOnboardingModal={setOpenOnboardingModal}
          showToast={showToast}
          invalidData={invalidData}
          updateMyData={updateMyData}
          agreement={true}
          type="Onboarding"
        />
      )}
    </Dialog>
  );

  return dialogData;
}
